export default () => `
  query {
    checkout {
      applePay {
        expressCheckoutRequest
      }
    }
  }
`
